import {
  useCreate, useDelete, useOne, useUpdate,
} from '@refinedev/core';

const RESOURCE = 'cp-user';

export const useUserService = () => {
  const { mutate: createMutate, isLoading: loadingCreate } = useCreate();
  const { mutate: updateMutate, isLoading: loadingUpdate } = useUpdate();
  const { mutate: deleteMutate, isLoading: loadingDelete } = useDelete();

  /**
   *
   * @param id
   * @returns
   */
  function getById(id: string) {
    return useOne({
      resource: RESOURCE,
      dataProviderName: 'auth',
      id,
    });
  }

  /**
   *
   * @param payload
   * @returns
   */
  async function create(payload: IUser): Promise<any> {
    return new Promise((resolve, reject) => {
      createMutate({
        resource: `${RESOURCE}/create`,
        dataProviderName: 'auth',
        values: payload,
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  /**
   *
   * @param id
   * @param payload
   * @returns
   */
  async function update(id: string, payload: IUserPayload): Promise<any> {
    return new Promise((resolve, reject) => {
      updateMutate({
        resource: `${RESOURCE}/:id/update`,
        dataProviderName: 'auth',
        id,
        values: payload,
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  /**
   *
   * @param id
   * @returns
   */
  async function remove(id: string, rowVersion: string, actorUserId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      deleteMutate({
        resource: `${RESOURCE}/:id/delete`,
        dataProviderName: 'auth',
        id,
        values: {
          row_version: rowVersion,
          user_id: id,
          actor_user_id: actorUserId,
        },
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  return {
    loadingCreate,
    loadingUpdate,
    loadingDelete,
    getById,
    create,
    update,
    remove,
    RESOURCE,
  };
};
